import { render, staticRenderFns } from "./DoctorFormReview.vue?vue&type=template&id=616874a9&scoped=true&"
import script from "./DoctorFormReview.vue?vue&type=script&lang=js&"
export * from "./DoctorFormReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616874a9",
  null
  
)

export default component.exports